define(function(require, exports, module) {
    var scrollTimeout = -1;
    var resizeTimeout = -1;

    var floorArray = {
        el: []
    };

    $(".lazy-fl").each(function() {
        if (!$(this).hasClass("load-done")) {
            floorArray.el.push($(this));
        }
    });

    exports.init = function(callback) {
        $(window).bind("scroll", function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function() {
                loadFloor(callback);
            }, 100)
        });
        $(window).bind("resize", function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                loadFloor(callback);
            }, 100)
        });
        $(document).trigger("scroll");
    };

    function loadFloor(callback) {
        for (var i = 0; i < floorArray.el.length; i++) {
            if (!inViewport(floorArray.el[i])) {
                continue;
            }
            var floorIdx = floorArray.el[i].attr("data-idx");
            renderFloor(floorIdx);

            floorArray.el.splice(i, 1);

            if($.isFunction(callback)) {
                callback(floorIdx)
            }
        }
    }

    function inViewport(el) {
        var scroll_top;
        if (document.documentElement && document.documentElement.scrollTop) {
            scroll_top = document.documentElement.scrollTop;
        } else if (document.body) {
            scroll_top = document.body.scrollTop;
        }

        var top = scroll_top;
        var btm = scroll_top + document.documentElement.clientHeight;
        var elTop = $(el).offset().top;

        var elBtm = elTop + $(el).height();
        if (elBtm >= top - 500 && elTop <= btm + 500) {
            return true;
        } else {
            return false;
        }
    }

    function renderFloor(floorIdx) {
        var floorHtml = $("#lazy-floor-" + floorIdx).html();
        $("[data-idx='" + floorIdx + "']").addClass("load-done").html(floorHtml);
        $("#lazy-floor-" + floorIdx).remove();
    }
});



// WEBPACK FOOTER //
// ./src/js/module/floor.js